import React, {Fragment} from 'react'
import PropTypes from 'prop-types'
import {Field} from 'redux-form'
import {useTranslations} from 'next-intl';
import {required} from '../../libs/validation'

import SelectField from '../Input/SelectField'
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid'


export const generateListData = (start, stop) => {
    const output = []
    let value, x
    for (x = start; x <= stop; x++) {
        value = `${x}`
        if (value.length === 1) {
            value = `0${x}`
        }
        output.push(value)
    }
    return output
}

const monthNames = {
    1: 'January',
    2: 'February',
    3: 'March',
    4: 'April',
    5: 'May',
    6: 'June',
    7: 'July',
    8: 'August',
    9: 'September',
    10: 'October',
    11: 'November',
    12: 'December',
}


let FullDate = ({...props}) => {
    const t = useTranslations('components.DateOfBirth');
    return (
        <Fragment>

            <Grid container spacing={2}>

                <Grid item xs={3}>
                    {!props.hideTitle &&
                    <Typography
                        variant="h6"
                        gutterBottom
                    >
                        {t('Day')}
                    </Typography>
                    }
                    <Field
                        name={props.nameDay || `background_check.dob.day`}
                        component={SelectField}
                        variant="outlined"
                        label={props.hideTitle ? t('Day') : undefined}
                        fullWidth={true}
                        // validate={required}
                        native
                    >
                        <option value=""></option>
                        {generateListData(1, 31).map(day => (
                            <option key={day} value={day}>{day}</option>
                        ))}
                    </Field>
                </Grid>


                <Grid item xs={3}>
                    {!props.hideTitle &&
                    <Typography
                        variant="h6"
                        gutterBottom
                    >
                        {t('Month')}
                    </Typography>
                    }
                    <Field
                        name={props.nameMonth || `background_check.dob.month`}
                        component={SelectField}
                        variant="outlined"
                        label={props.hideTitle ? t('Month') : undefined}
                        fullWidth={true}
                        // validate={required}
                        native
                    >
                        <option value=""></option>
                        {generateListData(1, 12).map(month => (
                            <option key={month} value={month}>{monthNames[Number(month)]}</option>
                        ))}
                    </Field>
                </Grid>

                {!props.hideYear &&
                <Grid item xs={6}>
                    {!props.hideTitle &&
                    <Typography
                        variant="h6"
                        gutterBottom
                    >
                        {t('Year')}
                    </Typography>
                    }
                    <Field
                        name={props.nameYear || `background_check.dob.year`}
                        component={SelectField}
                        variant="outlined"
                        label={props.hideTitle ? t('Year') : undefined}
                        fullWidth={true}
                        // validate={required}
                        native
                    >
                        <option value=""></option>
                        {generateListData(props.startYear || 1930, props.stopYear || 2015).map(year => (
                            <option key={year} value={year}>{year}</option>
                        ))}
                    </Field>
                </Grid>
                }

            </Grid>

        </Fragment>
    )
}

FullDate.propTypes = {
    nameDay: PropTypes.string,
    nameMonth: PropTypes.string,
    nameYear: PropTypes.string,
    stopYear: PropTypes.number,
    startYear: PropTypes.number,
    hideTitle: PropTypes.bool,
}

export default FullDate